import type { IAppsIosIdentifierFilter } from "../../../types/iosFiltersDto";

export enum AppsIdentifiers {
    PackageName = "Package name",
    BundleId = "Bundle ID",
    TrackId = "Track ID",
}

export type IosIdentifierType = keyof IAppsIosIdentifierFilter;
